

export interface DecorationProvider {
}
